export default (selectedScale) => ({
  1: 5.5,
  2: 5,
  3: 50,
  4: 50,
}[selectedScale]);
